import React from 'react';
import { Link } from 'react-router-dom';
import { Calculator, ArrowRight, Sparkles } from 'lucide-react';
import { locativeAdjectiveCity } from '../utils/turkishLocative';

/**
 * Compact Nişan Hesaplayıcı banner for venue detail page sidebar.
 * Narrower/shorter than the homepage variant.
 */
const NisanHesaplayiciCompactBanner = ({ cityName = null }) => {
  const cityLabel = cityName ? locativeAdjectiveCity(cityName) : 'Sizin şehrinizdeki';

  return (
    <Link
      to="/nisan-maliyeti-hesaplama"
      className="group block rounded-2xl overflow-hidden ring-1 ring-rose-100 bg-white shadow-sm hover:shadow-md transition-shadow"
      data-testid="nisan-hesaplayici-compact-banner"
    >
      <div className="relative bg-gradient-to-br from-rose-500 via-rose-500 to-pink-600 px-5 py-5 sm:px-6 sm:py-6 overflow-hidden">
        {/* Decorative accents */}
        <div
          className="absolute inset-0 opacity-25 pointer-events-none"
          style={{
            backgroundImage:
              'radial-gradient(circle at 88% 15%, rgba(255,255,255,0.5) 0%, transparent 45%), radial-gradient(circle at 10% 85%, rgba(255,255,255,0.25) 0%, transparent 50%)'
          }}
          aria-hidden="true"
        />

        <div className="relative flex items-center gap-4">
          {/* Icon block */}
          <div className="shrink-0 h-14 w-14 rounded-2xl bg-white/95 shadow-lg flex items-center justify-center ring-1 ring-white/40">
            <Calculator className="h-7 w-7 text-rose-600" strokeWidth={2.4} />
          </div>

          {/* Text */}
          <div className="min-w-0 flex-1 text-white">
            <div className="inline-flex items-center gap-1 rounded-full bg-white/20 backdrop-blur px-2 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.14em]">
              <Sparkles className="h-2.5 w-2.5" strokeWidth={2.6} />
              Ücretsiz Araç
            </div>
            <h3 className="mt-1.5 font-display text-[17px] sm:text-[19px] font-semibold leading-tight tracking-tight">
              {cityLabel} nişanınız <span className="italic font-normal">ne kadara mal olur?</span>
            </h3>
            <p className="mt-1 text-[12.5px] text-white/85 leading-snug">
              60 saniyede detaylı bütçe tahmini
            </p>
          </div>

          {/* Arrow */}
          <div className="shrink-0 h-10 w-10 rounded-full bg-white/95 flex items-center justify-center shadow-md ring-1 ring-white/50 group-hover:translate-x-0.5 transition-transform">
            <ArrowRight className="h-4.5 w-4.5 text-rose-600" strokeWidth={2.6} />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NisanHesaplayiciCompactBanner;
